import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { closeSvg, linkArrowLeft } from "../../svgs";
import { FlexCenter } from "../../styles";
import PortalContext from "../../context/portalContext";
import DataContext from "../../context/dataContext";
import { useForgotPassword } from "../../apiHooks/auth";

import CustomInput from "../inputs";
import Image from "../imageComponent";
import {
  ModalWrapper,
  AuthContent,
  UpdateWrapper,
  SuccessWrapper,
} from "./styled";
import ErrorNotification from "./notifications";

const UpdatePassword: React.FC = () => {
  // translation
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const modalWrapper = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [stepTwo, setStepTwo] = useState(false);
  const [successfulUpdate, setSuccess] = useState(false);

  const { authErrors, setAuthErrors, successMsgs } = useContext(DataContext);
  const { openLogin, closeAuthPortals } = useContext(PortalContext);

  const { forgotPassword, status } = useForgotPassword();

  const sendCode = (data) => {
    forgotPassword({ params: { ...data, email: data.email.trim() } });
  };

  // modal
  const outsideClick = (e) => {
    return e.target === modalWrapper.current && closeAuthPortals();
  };

  useEffect(() => {
    setIsOpen(true);
    // dispatch(clearSignIn());
    // dispatch(checkAnalyticsId('recover_popup'));
    document.querySelector("body").classList.add("fixed");
    window.addEventListener("click", outsideClick);

    return () => {
      document.querySelector("body").classList.remove("fixed");
      window.removeEventListener("click", outsideClick);
      setAuthErrors([]);
      // dispatch(clearSignIn());
      // dispatch(clearReset());
    };
  }, []);

  useEffect(() => {
    if (status === "success") {
      setAuthErrors([]);
      setStepTwo(true);
      setSuccess(true);
    }
  }, [status]);

  useEffect(() => {
    console.log(errors, authErrors[0]);
    setAuthErrors([]);
  }, [Object.keys(errors).length]);

  return (
    <ModalWrapper open={isOpen} ref={modalWrapper}>
      <AuthContent>
        <div className="auth-content -recover">
          <button className="close" onClick={() => closeAuthPortals()}>
            {closeSvg()}
            <FlexCenter>{linkArrowLeft()}</FlexCenter>
          </button>

          {!successfulUpdate && !stepTwo && (
            <button onMouseUp={() => openLogin()} className="back">
              {linkArrowLeft()}
              {t("back")}
            </button>
          )}

          {!successfulUpdate && stepTwo && (
            <button onMouseUp={() => setStepTwo(false)} className="back">
              {" "}
              {linkArrowLeft()}
              {t("back")}
            </button>
          )}

          {!successfulUpdate ? (
            <UpdateWrapper>
              <div className="headline">{t("updateYourPassword")}</div>
              <p className="description">{t("passwordLink1")}</p>

              {/* first step */}
              <form autoComplete="off" onSubmit={handleSubmit(sendCode)}>
                {(authErrors && authErrors[0] && authErrors[0].length) ||
                Object.keys(errors).length ? (
                  <ErrorNotification
                    errorText={
                      errors?.email?.message?.toString() || authErrors[0]
                    }
                  />
                ) : null}

                <CustomInput
                  disabled={stepTwo}
                  margin="0 0 16px"
                  inputType="text"
                  id="signin-password"
                  inputName={t("email")}
                  reactHookOptions={register("email", {
                    required: {
                      value: true,
                      message: t("emailRequired"),
                    },
                    pattern: {
                      value:
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: t("emailNotValid"),
                    },
                  })}
                  errors={errors.email}
                  // errorMessages={<>{errors.email && <span>{t('fieldIsRequired')}</span>}</>}
                />
                {/* {errors.email && <sup>{t('fieldIsRequired')}</sup>} */}

                {!stepTwo && (
                  <>
                    <button className="primary">{t("sendMeLink")}</button>

                    {/* <FlexCenter className="login">
                       {t('passwordRemember?')}
                      <button onMouseUp={() => dispatch(openLogin())}>{t('signIn')}</button>
                    </FlexCenter> */}
                  </>
                )}
              </form>
            </UpdateWrapper>
          ) : (
            <SuccessWrapper>
              <div className="hero">
                <Image
                  src="/images/success-mail.PNG"
                  layout="fill"
                  objectFit="contain"
                  contain
                />
              </div>

              <div className="headline">{t("passwordLink2")}</div>

              <p className="description">{t("passwordLink3")}</p>

              <FlexCenter className="send-again">
                {t("cantGetMail")}
                <button
                  onClick={() => {
                    setSuccess(false);
                    setStepTwo(false);
                    // dispatch(clearReset());
                  }}
                >
                  {t("sendAgain")}
                </button>
              </FlexCenter>
            </SuccessWrapper>
          )}
        </div>
      </AuthContent>
    </ModalWrapper>
  );
};

export default UpdatePassword;
